import { persistedUiParam } from '@/frontend/pages/Dashboard/AgentChats/runtime/assistantUiToggle'

// Shared chat-access semantics of the worker-first shell. Sidebar, palette and
// AgentPicker all use this canonical entry into an agent's chat.

/**
 * Entry into the agent chat — agora a ABA Chat do portal (Iteração 3, B/C):
 * /dashboard/digital_workers/:id/chat. Preserva o fallback ?ui=legacy quando
 * ativo. `newConversation` adiciona ?new_conversation=1, que o controller honra
 * NÃO auto-abrindo a sessão mais recente. (A rota antiga /dashboard/agent_chats
 * segue viva como 302 pra cá, então bookmarks/deep-links continuam.)
 */
export function agentChatHref(
  workerId: string,
  { newConversation = false, sessionId }: { newConversation?: boolean; sessionId?: string } = {},
): string {
  const params = new URLSearchParams()
  if (sessionId) params.set('session_id', sessionId)
  if (newConversation) params.set('new_conversation', '1')
  const ui = persistedUiParam()
  if (ui) params.set('ui', ui)
  const query = params.toString()
  return `/dashboard/digital_workers/${workerId}/chat${query ? `?${query}` : ''}`
}

/**
 * Página dedicada de início de conversa (Iteração 3): saudação + seletor de
 * agente + composer. É o destino de "Nova conversa" (sidebar + ⌘N) e de
 * "Conversar" da home. Preserva ?ui=legacy para o composer legado continuar
 * disponível na aba Chat de destino após o envio.
 */
export function newConversationHref(): string {
  const ui = persistedUiParam()
  return `/dashboard/agent_chats/new${ui ? `?ui=${ui}` : ''}`
}
